import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ST_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#ST_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v24h32V0H0z", fill: "#FBCD17" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0zM0 16v8h32v-8H0z", fill: "#73BE4A" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0v24l10-12L0 0z", fill: "#C51918" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.002 13.87L15.132 15l.426-2.204L14 11.146l2.11-.088L17.001 9l.892 2.058H20l-1.554 1.738.468 2.204-1.912-1.13zM25.002 13.87L23.132 15l.426-2.204L22 11.146l2.11-.088L25.001 9l.892 2.058H28l-1.554 1.738.468 2.204-1.912-1.13z",
      fill: "#272727"
    }
  ))
), a = t;
export {
  a as default
};
